module.exports = __webpack_public_path__ + "img/logo.06faf1dc.png";